import {h, Fragment} from "preact"
import { useAppState, useActions } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks"
import NoResults from "./NoResults"
import Products from "./Products"
import Toolbar from "./Toolbar"
import Sidebar from "./Sidebar"
import Pagination from "./Pagination"
import Loader from "./elements/Loader"

export default function Category() {
    const {
        response: { products },
        loading, query
    } = useAppState()
    const foundProducts = products && products.total > 0
    const toggleButtonId = "toggle-mobile-sidebar"
    const [openedSidebar, setOpenedSidebar] = useState(false)

    return (
        <div class="ns-serp container relative grid grid-cols-12 gap-7">
            {foundProducts && (
                <>
                    <Sidebar toggleId={toggleButtonId} openedSidebar={openedSidebar} setOpenedSidebar={setOpenedSidebar} />
                </>
            )}
            <div class={`ns-d-block col-span-12 ${openedSidebar ? 'lg:col-span-9' : ''}`}>
                {foundProducts ? (
                    <>
                        <Toolbar labelFor={toggleButtonId} openedSidebar={openedSidebar} setOpenedSidebar={setOpenedSidebar} />
                        <Products openedSidebar={openedSidebar} />
                        <Pagination />
                    </>
                ) : loading ? (
                    <Loader />
                ) : (
                    <NoResults />
                )}
            </div>
        </div>
    )
}
